import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
// tslint:disable:max-line-length
import React from 'react';
export var UtilitySettings = function UtilitySettings(props) {
  var _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? 'Settings' : _props$ariaLabel,
      remProps = _objectWithoutProperties(props, ["ariaLabel"]);

  return React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16",
    "aria-label": ariaLabel
  }, remProps), React.createElement("path", {
    d: "M6.25,8.89A2.19,2.19,0,0,0,7.41,10a2.18,2.18,0,0,0,1.7,0,2.17,2.17,0,0,0,1.16-1.15,2.18,2.18,0,0,0,0-1.7A2.16,2.16,0,0,0,9.1,6a2.18,2.18,0,0,0-1.7,0A2.17,2.17,0,0,0,6.25,7.2a2.18,2.18,0,0,0,0,1.7ZM3.48,11a6.06,6.06,0,0,1-.72-1.6H0V6.7H2.73A6.08,6.08,0,0,1,3,5.85a4.88,4.88,0,0,1,.41-.78L1.56,3.19l1.9-1.9,1.9,1.92a6.7,6.7,0,0,1,.74-.36,4.56,4.56,0,0,1,.8-.24V0H9.6V2.66a4.69,4.69,0,0,1,.79.29,5.89,5.89,0,0,1,.72.41L13,1.45l1.9,1.9-2,2q.17.33.31.67a4.72,4.72,0,0,1,.22.71H16V9.39H13.45a4,4,0,0,1-.23.7,5.84,5.84,0,0,1-.33.64l1.89,1.87-1.9,1.9L11,12.67a5.35,5.35,0,0,1-1.43.64V16H6.91V13.38a5.46,5.46,0,0,1-1.46-.56L3.61,14.67l-1.9-1.9Z"
  }));
};